import { AppState } from '../../model/application/types';
import { AppActionTypes, initAppActionType, updateBearerActionType } from '../../model/application/actions';

const initialState: AppState = {
  bearer: "",
  isInitialized: false,
};

export function AppReducer(
  state = initialState,
  action: AppActionTypes,
): AppState {
  switch (action.type) {
    case initAppActionType.success:
      return {
        ... state,
        isInitialized: true,
      };
    case updateBearerActionType:
        return {
          ... state,
          bearer: action.payload,
        };
    default:
      return state;
  }
}
